import React, { useState, useEffect, useRef } from 'react';

export function InsufficientBalanceSheet({
                                             isVisible,
                                             onClose,
                                             requiredAmount,
                                             currentBalance,
                                             onGoWallet
                                         }) {
    const [startY, setStartY] = useState(null);
    const [currentY, setCurrentY] = useState(null);
    const sheetRef = useRef(null);

    useEffect(() => {
        if (isVisible) {
            document.body.style.overflow = 'hidden';
            document.body.classList.add('sheet-open');
        } else {
            document.body.style.overflow = '';
            document.body.classList.remove('sheet-open');
        }

        return () => {
            document.body.style.overflow = '';
            document.body.classList.remove('sheet-open');
        };
    }, [isVisible]);

    const handleTouchStart = (e) => {
        setStartY(e.touches[0].clientY);
    };

    const handleTouchMove = (e) => {
        if (startY === null) return;

        const currentTouchY = e.touches[0].clientY;
        const diff = currentTouchY - startY;

        if (diff > 0) {
            e.preventDefault();
            setCurrentY(diff);

            if (sheetRef.current) {
                const maxTranslate = window.innerHeight * 0.5;
                const translateY = Math.min(diff, maxTranslate);
                sheetRef.current.style.transform = `translateY(${translateY}px)`;
            }
        }
    };

    const handleTouchEnd = () => {
        if (startY === null) return;

        const diff = currentY || 0;

        if (diff > 100) {
            onClose();
        }

        if (sheetRef.current) {
            sheetRef.current.style.transform = '';
        }

        setStartY(null);
        setCurrentY(null);
    };

    const handleMouseDown = (e) => {
        setStartY(e.clientY);

        const handleMouseMove = (e) => {
            if (startY === null) return;

            const diff = e.clientY - startY;

            if (diff > 0) {
                setCurrentY(diff);

                if (sheetRef.current) {
                    const maxTranslate = window.innerHeight * 0.5;
                    const translateY = Math.min(diff, maxTranslate);
                    sheetRef.current.style.transform = `translateY(${translateY}px)`;
                }
            }
        };

        const handleMouseUp = () => {
            const diff = currentY || 0;

            if (diff > 100) {
                onClose();
            }

            if (sheetRef.current) {
                sheetRef.current.style.transform = '';
            }

            setStartY(null);
            setCurrentY(null);

            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    const handleGoToWallet = () => {
        onGoWallet();
        onClose();
    };

    return (
        <div className={`confirmation-sheet-wrapper ${isVisible ? 'visible' : ''}`}>
            <div
                className="sheet-overlay"
                onClick={onClose}
            />

            <div
                ref={sheetRef}
                className="confirmation-sheet balance"
                style={{
                    paddingTop: '12px',
                    paddingLeft: '16px',
                    paddingRight: '16px'}}
            >
                <div className="sheet-content" style={{ gap: '12px' }}>
                    <div
                        className="sheet-drag-handle"
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                        onMouseDown={handleMouseDown}
                    >
                        <div className="drag-indicator" style={{ width: '32px', height: '3px' }} />
                    </div>

                    <h3 className="sheet-title" style={{ fontSize: '18px', margin: '0', textAlign: 'center' }}>
                        Недостаточно средств
                    </h3>

                    <div style={{ textAlign: 'center' }}>
                        <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '14px', margin: 0 }}>
                            Для продления VPN не хватает {requiredAmount}₽
                        </p>
                    </div>

                    {/* Блок с балансом */}
                    <div className="custom-content-box" style={{
                        background: 'linear-gradient(40deg, rgba(64, 82, 73, 0.3) 50%, #2a5a3a 100%)',
                        borderRadius: '12px',
                        padding: '16px, 0, 25px, 0',
                        marginBottom: '0',
                        border: 'none'

                    }}>
                        <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '14px', marginBottom: '8px' }}>
                            Баланс кошелька
                        </div>
                        <div style={{ color: '#ffffff', fontSize: '28px', fontWeight: '700', marginBottom: '16px'}}>
                            ₽{currentBalance}
                        </div>
                        <button
                            onClick={handleGoToWallet}
                            className={"btn btn-green"}
                        >
                            Пополнить
                        </button>
                    </div>

                    {/* Кнопка закрытия */}
                    <button
                        onClick={onClose}
                        style={{
                            width: '100%',
                            padding: '12px',
                            background: 'transparent',
                            border: '1px solid rgba(255,255,255,0.2)',
                            borderRadius: '12px',
                            color: 'white',
                            fontSize: '14px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            marginTop: '4px'
                        }}
                    >
                        Закрыть
                    </button>
                </div>
            </div>
        </div>
    );
}